import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from "react-hook-form";
import {getLanguage, t} from "react-switch-lang";
import SelectInfinite from '../../../../../components/FormFields/SelectInfinite'
import * as yup from "yup";
import {Row, Col, Spinner} from 'react-bootstrap';
import {yupResolver} from "@hookform/resolvers";
import InputText from "../../../../../components/FormFields/InputText";
import InputDate from '../../../../../components/FormFields/inputDate/InputDate'
import TextArea from "../../../../../components/FormFields/Textarea";
import {format, parseISO} from 'date-fns';
import {
    createCreditRiskManagementForm, editCreditRiskManagementForm, getCreditRiskManagementOverallRiskAssessmentLevels,getCreditRiskManagementForm
} from "../../../../../services/externalizations/creditRiskManagementService";
import {Toast} from "../../../../../utils/sweetAlert";
import {useParams} from 'react-router-dom';
import {
  customStyles,
  handleCancelExternalization,
  isUserReviewer, statusesOfVerification,
} from '../../../../../utils/externalizationFormOptions';
import {Tooltip} from 'antd';
import {InfoCircleOutlined} from '@ant-design/icons';
import Swal from 'sweetalert2';
import {useExternalizationContext} from '../../../../../contexts/ExternalizationContext';
import {useUserContext} from '../../../../../contexts/UserContext';
import VerifyExternalizationModal from '../../../components/verifyExternalizationModal/VerifyExternalizationModal';
import FormActionButtons from '../../../components/formActionButtons/FormActionButtons';

function ManagingCreditRisksForm({cycleId, isLastCycle, isEditAllowedByStatus, isVerified, externalizationFormConfigData}) {
    const [disabled, setDisabled] = useState(false);
    const [managingCreditRisksFormId, setManagingCreditRisksFormId] = useState(false);
    const [loading,setLoading] = useState(false);
    const [isReview,setIsReview] = useState(false);
    const [populated,setPopulated] = useState(false);
    const [showEditBtn,setShowEditBtn] = useState(false);
    const [defaultData,setDefaultData] = useState([]);
  const [totalRiskAssessment, setTotalRiskAssessment] = useState([])
  const [riskDescription, setRiskDescription] = useState('')
  const {id} = useParams()
  const [edit,setEdit] = useState(showEditBtn);
  const externalizationConfigData = useExternalizationContext();
  const user = useUserContext()
  const [responsibleUserId, setResponsibleUserId] = useState()
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const [verificationStatus, setVerificationStatus]= useState('')
  const canVerify = verificationStatus === 'PENDING'
  const userCanVerifyForm = user?.id === responsibleUserId
  const toggleVerifyModal = () => setVerifyModalOpen(prev => !prev);
  const schema = yup.object().shape({
      processingDate: yup.date()
        .nullable()
        .typeError(t('message.fieldRequired'))
        .required(t('message.fieldRequired')),
        serviceProviderCreditRatingRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
        affiliatedEntitiesCreditRatingRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
        financialReportingDeficiencyRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
        creditRiskManagementOverallRiskAssessmentLevel: yup.object().nullable(),
        comment: yup
            .string()
            .trim()
            .max(2000, t('message.max', {max: 2000}))
    });

    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const {handleSubmit, setValue, watch, reset} = methods;

    const serviceProviderCreditRatingRiskLevel = watch('serviceProviderCreditRatingRiskLevel');
    const affiliatedEntitiesCreditRatingRiskLevel = watch('affiliatedEntitiesCreditRatingRiskLevel');
    const financialReportingDeficiencyRiskLevel = watch('financialReportingDeficiencyRiskLevel');
    const creditRiskManagementOverallRiskAssessmentLevel = watch('creditRiskManagementOverallRiskAssessmentLevel');
  const values = [
    serviceProviderCreditRatingRiskLevel?.value,
    affiliatedEntitiesCreditRatingRiskLevel?.value,
    financialReportingDeficiencyRiskLevel?.value
  ].filter(v => v != null);

  const rawMaxValue = values.length ? Math.max(...values) : null;

  const maxValue = rawMaxValue != null ? rawMaxValue - 1 : null;
  const lang = getLanguage();

    const submitForm = async (data) => {
      const formatProcessingDate =
        format(new Date(data?.processingDate), 'yyyy-MM-dd');
        setDisabled(true);
        const dataToSubmit = {
          ...(edit && {
            id: defaultData?.id ? defaultData?.id : managingCreditRisksFormId,
          }),
            processingDate: formatProcessingDate,
            creditRiskManagementOverallRiskAssessmentLevel: {id: data?.creditRiskManagementOverallRiskAssessmentLevel?.value},
            comment: data?.comment,
            serviceProviderCreditRatingRiskLevel: {id: data?.serviceProviderCreditRatingRiskLevel.value},
            affiliatedEntitiesCreditRatingRiskLevel: {id: data?.affiliatedEntitiesCreditRatingRiskLevel.value, },
            financialReportingDeficiencyRiskLevel: {id: data?.financialReportingDeficiencyRiskLevel.value},
          formConfig: externalizationFormConfigData,
          populated: true,
          cycle: {id: parseInt(cycleId)},
          userInCharge: {id: externalizationFormConfigData?.defaultDepartment?.userInChargeForExternalizationId},
          responsibleUser: {id: externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId}
        }
        if(edit) {
          try{
            const res = await editCreditRiskManagementForm(defaultData?.id ? defaultData?.id : managingCreditRisksFormId,dataToSubmit)
                if (res?.status === 200) {
                    Toast.fire({
                        title: t('departments.message.updateSuccess', {
                            entity: t('externalization.managingCreditRisksForm.creditRiskManagement'),
                        }),
                        icon: 'success',
                    });
                  const newVerificationStatus = res?.data?.verificationStatus;
                  if (newVerificationStatus && newVerificationStatus !== verificationStatus) {
                    setTimeout(() => {
                      window.location.reload();
                    }, 800);
                  } else {
                    setVerificationStatus(newVerificationStatus);
                    setDisabled(true);
                  }
                }
              setDisabled(true);
            } catch (err){
            if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
              Swal.fire({
                text:
                  lang === 'eng'
                    ? err.response.data.description
                    : t('message.responsibleUserForExternalizationMissing'),
                icon: 'error',
              });
              setDisabled(false)
              setEdit(false)
            } else {
              Toast.fire({
                title: t('message.errorApi'),
                icon: 'error',
              });
            }
          }
        }else {
          try {
            const response = await createCreditRiskManagementForm(dataToSubmit)
                if (response?.status === 201) {
                    Toast.fire({
                        title: t('departments.message.addSuccess', {
                            entity: t('externalization.managingCreditRisksForm.creditRiskManagement'),
                        }),
                        icon: 'success',
                    });
                    setDisabled(true)
                    setEdit(true)
                    setIsReview(true);
                  setVerificationStatus('PENDING')
                  setManagingCreditRisksFormId(response?.data?.id)
                  setResponsibleUserId(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId);
                }
            } catch (err){
        if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
          Swal.fire({
            text:
              lang === 'eng'
                ? err.response.data.description
                : t('message.responsibleUserForExternalizationMissing'),
            icon: 'error',
          });
          setDisabled(false)
          setEdit(false)
        } else {
          Toast.fire({
            title: t('message.errorApi'),
            icon: 'error',
          });
        }
      }
        }

    }
  useEffect(() => {
    async function fetchRiskLevels() {
      const {data} = await getCreditRiskManagementOverallRiskAssessmentLevels();
      const validLevels = data.filter(r => r.value >= 0 && r.value <= 2);
      setTotalRiskAssessment(validLevels);
    }
    fetchRiskLevels();
  }, []);


  function getRiskAssessmentDTO(riskValue, riskLevelList) {
    return riskLevelList.find(r => r.value === riskValue);
  }
  useEffect(() => {
    if (maxValue != null && totalRiskAssessment.length > 0) {
      const dto = getRiskAssessmentDTO(maxValue, totalRiskAssessment);
      if(dto) {
        const transformed = {
          value: dto.id,
          label: lang === 'mne' ? dto.name : dto.nameEn
        };
        setValue('creditRiskManagementOverallRiskAssessmentLevel', transformed);
      }
    }
  }, [serviceProviderCreditRatingRiskLevel,
    affiliatedEntitiesCreditRatingRiskLevel,
    financialReportingDeficiencyRiskLevel, totalRiskAssessment]);
  useEffect(() => {
    if (creditRiskManagementOverallRiskAssessmentLevel && totalRiskAssessment.length > 0) {
      const matchedRisk = totalRiskAssessment.find(
        (item) => item.id === creditRiskManagementOverallRiskAssessmentLevel.value
      );
      if (matchedRisk) {
        setRiskDescription({
          value: matchedRisk.value,
          label: lang === 'mne' ? matchedRisk.description : matchedRisk.descriptionEn,
        });
      }
    }
  }, [creditRiskManagementOverallRiskAssessmentLevel, totalRiskAssessment]);

  useEffect(() => {
      async function fetchCreditRiskManagementForm() {
          setLoading(true);
          try {
              const res = await getCreditRiskManagementForm(cycleId);
              const form = res?.data?.[0] ?? null;

              if (form) {
                  setDefaultData(form);
                  setPopulated(!!form?.populated);
                  setEdit(!!form?.populated);
                  setDisabled(!!form?.populated);
                setResponsibleUserId(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId)
                setVerificationStatus(form?.verificationStatus)
                  setIsReview(!!form?.populated && isUserReviewer(externalizationConfigData,user,'creditRiskManagementForm'));
                  setShowEditBtn(!form?.populated === false || !isUserReviewer(externalizationConfigData,user,'creditRiskManagementForm'));
              } else {
                  setPopulated(false);
                  setEdit(false);
                  setDisabled(!isUserReviewer(externalizationConfigData,user,'creditRiskManagementForm'));
                  setValue('processingDate', new Date());
              }
          } catch (err) {
              console.error('Error loading bank risk profile form:', err);
              setPopulated(false);
          } finally {
              setLoading(false);
          }
      }
      fetchCreditRiskManagementForm();
    }, [cycleId]);
  useEffect(() => {
    reset({
      processingDate: defaultData?.processingDate
        ? parseISO(defaultData.processingDate)
        : new Date(),
      serviceProviderCreditRatingRiskLevel: defaultData?.serviceProviderCreditRatingRiskLevel
        ? {
          value: defaultData.serviceProviderCreditRatingRiskLevel.id,
          label: lang === 'eng' ? defaultData.serviceProviderCreditRatingRiskLevel.nameEn :defaultData.serviceProviderCreditRatingRiskLevel.name,
        }
        : null,
      affiliatedEntitiesCreditRatingRiskLevel: defaultData?.affiliatedEntitiesCreditRatingRiskLevel
        ? {
          value: defaultData.affiliatedEntitiesCreditRatingRiskLevel.id,
          label: lang === 'eng' ? defaultData.affiliatedEntitiesCreditRatingRiskLevel.nameEn :defaultData.affiliatedEntitiesCreditRatingRiskLevel.name,
        }
        : null,
      financialReportingDeficiencyRiskLevel: defaultData?.financialReportingDeficiencyRiskLevel
        ? {
          value: defaultData.financialReportingDeficiencyRiskLevel.id,
          label: lang === 'eng' ? defaultData.financialReportingDeficiencyRiskLevel.nameEn :defaultData.financialReportingDeficiencyRiskLevel.name,
        }
        : null,
      creditRiskManagementOverallRiskAssessmentLevel: defaultData?.creditRiskManagementOverallRiskAssessmentLevel
        ? {
          value: defaultData.creditRiskManagementOverallRiskAssessmentLevel.id,
          label: lang === 'eng' ? defaultData.creditRiskManagementOverallRiskAssessmentLevel.nameEn :defaultData.creditRiskManagementOverallRiskAssessmentLevel.name,
        }
        : null,
    });
  }, [defaultData]);

    if (loading) {
        return (
            <div className="text-center mt-4 mb-4">
                <Spinner animation="border" role="status" />
            </div>
        );
    }

    return (<>
      <FormActionButtons
        isReview={isReview}
        edit={edit}
        disabled={disabled}
        isLastCycle={isLastCycle}
        isEditAllowedByStatus={isEditAllowedByStatus}
        userCanVerifyForm={userCanVerifyForm}
        canVerify={canVerify}
        toggleVerifyModal={toggleVerifyModal}
        setDisabled={setDisabled}
      />
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(submitForm)}>
                <Row className="mb-4">
                    <Col className="col-6 col-xl-3">
                        <label className="label w-100 mt-2">
                            {t('departments.department')}
                        </label>
                        <SelectInfinite
                            api="departments"
                            name="departmentInCharge"
                            labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                            className="select"
                            isDisabled={true}
                            defaultValue={
                              externalizationFormConfigData?.defaultDepartment
                                ? {
                                  value: externalizationFormConfigData?.defaultDepartment?.id,
                                  label:
                                    lang === 'mne'
                                      ? externalizationFormConfigData?.defaultDepartment?.name
                                      : externalizationFormConfigData?.defaultDepartment?.nameEn,
                                }
                                : null
                            }
                        />
                      <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.date')}
                      </label>
                      <InputDate
                        name="processingDate"
                        className={'date-input'}
                        defaultValue={defaultData?.processingDate !== undefined ? format(new Date(defaultData?.processingDate), 'yyyy-MM-dd') : new Date()}
                        disabled={disabled}
                      />
                    </Col>
                    <Col className="col-6 col-xl-3">
                        <label className="label w-100 mt-2" htmlFor="serviceProviderCreditRisk">
                            {t(`externalization.managingCreditRisksForm.serviceProviderCreditRisk`)}
                          <span className="optional register line-height pt-1">
                            <Tooltip
                              title={t('externalization.managingCreditRisksForm.serviceProviderCreditRiskTooltip')}
                              overlayClassName="custom-tooltip"
                              placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip>
                         </span>
                        </label>
                      <SelectInfinite
                        api="service-provider-credit-rating-risk-levels"
                        name="serviceProviderCreditRatingRiskLevel"
                        placeholder={t(`externalization.managingCreditRisksForm.placeholder.serviceProviderCreditRisk`)}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        hasTooltipDescription={true}
                        isDisabled={disabled}/>
                        <label className="label w-100 mt-2" htmlFor='creditRiskOfRelatedParties'>
                            {t(`externalization.managingCreditRisksForm.creditRiskOfRelatedParties`)}
                          <span className="optional register line-height pt-1">
                            <Tooltip
                              title={t('externalization.managingCreditRisksForm.creditRiskOfRelatedPartiesTooltip')}
                              overlayClassName="custom-tooltip"
                              placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip>
                         </span>
                        </label>
                      <SelectInfinite
                        api="affiliated-entities-credit-rating-risk-levels"
                        name="affiliatedEntitiesCreditRatingRiskLevel"
                        placeholder={t(`externalization.managingCreditRisksForm.placeholder.creditRiskOfRelatedParties`)}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        hasTooltipDescription={true}
                        isDisabled={disabled}
                      />
                      <label className="label w-100 mt-2" htmlFor='financialReportingDeficiencyRiskLevel'>
                        {t(`externalization.managingCreditRisksForm.financialStatementDeficiencyRisk`)}
                        <span className="optional register line-height pt-1">
                            <Tooltip
                              title={t('externalization.managingCreditRisksForm.financialStatementDeficiencyRiskTooltip')}
                              overlayClassName="custom-tooltip"
                              placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip>
                         </span>
                      </label>
                      <SelectInfinite
                        api="financial-reporting-deficiency-risk-levels"
                        name="financialReportingDeficiencyRiskLevel"
                        placeholder={t(`externalization.managingCreditRisksForm.placeholder.financialStatementDeficiencyRisk`)}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        hasTooltipDescription={true}
                        isDisabled={disabled}
                      />
                        <label className="label w-100 mt-2">
                            {t('comments.comment')}
                                  <span className="pl-2 d-inline-flex">
                            <Tooltip
                              title={t('externalization.managingCreditRisksForm.commentTooltip')}
                              overlayClassName="custom-tooltip"
                              placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span>
                          <span className="optional register line-height">{t('common.optional')}</span>
                        </label>
                        <TextArea
                            name="comment"
                            className={`form-control text-area `}
                            placeholder={t('placeholder.comment')}
                            disabled={disabled}
                            defaultValue={defaultData?.comment}
                        />
                    </Col>
                    <Col className="col-6 col-xl-3">
                      <label className="label w-100 mt-2" htmlFor="riskAssessment">
                        {t('externalization.riskProponentForm.riskAssessment')}
                      </label>
                      <SelectInfinite
                        options={totalRiskAssessment}
                        name="creditRiskManagementOverallRiskAssessmentLevel"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={true}
                        placeholder={''}
                        styles={customStyles}
                        defaultValue={
                          defaultData?.creditRiskManagementOverallRiskAssessmentLevel?.id
                            ? {
                              value: defaultData?.creditRiskManagementOverallRiskAssessmentLevel?.id,
                              label:
                                lang === 'mne'
                                  ? defaultData?.creditRiskManagementOverallRiskAssessmentLevel?.name
                                  : defaultData?.creditRiskManagementOverallRiskAssessmentLevel?.nameEn
                            }
                            : null
                        }
                      />
                      <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.riskDesc')}
                      </label>
                      <textarea
                        key={riskDescription}
                        value={riskDescription?.label}
                        type="text"
                        defaultValue={lang === 'mne' ? defaultData?.creditRiskManagementOverallRiskAssessmentLevel?.description : defaultData?.creditRiskManagementOverallRiskAssessmentLevel?.descriptionEn}
                        disabled={true}
                        rows={4}
                      />
                            <label className="label w-100 mt-2">
                                {t('externalization.riskProponentForm.analysisDoneBy')}
                            </label>
                          <InputText
                            type="text"
                            name="userInCharge"
                            className="form-control input-field"
                            disabled={true}
                            id="userInCharge"
                            defaultValue={externalizationFormConfigData?.defaultDepartment.userInChargeForExternalizationFullName}
                          />
                      {externalizationFormConfigData?.defaultDepartment?.deputyUserInChargeForExternalizationFullName && <>
                        <label className="label w-100 mt-2">{t('departments.userInChargeReplacementForExternalization')}</label>
                        <InputText
                          type="text"
                          name="userInChargeDeputy"
                          className="form-control input-field"
                          disabled={true}
                          id="userInCharge"
                          defaultValue={externalizationFormConfigData?.defaultDepartment?.deputyUserInChargeForExternalizationFullName}
                        /></>}
                          <label className="label w-100 mt-2">
                            {t('externalization.riskProponentForm.verificationDoneBy')}
                          </label>
                          <InputText
                            type="text"
                            name="responsibleUser"
                            className="form-control input-field"
                            disabled={true}
                            id="responsibleUser"
                            defaultValue={externalizationFormConfigData?.defaultDepartment.userResponsibleForExternalizationFullName} />
                      {edit && <>  <label className="label w-100 mt-2">{t('externalization.verificationStatus')}</label>
                        <InputText
                          name="verificationStatus"
                          type="text"
                          className="form-control input-field"
                          placeholder={t( 'externalization.placeholder.verificationStatus')}
                          disabled={true}
                          defaultValue={statusesOfVerification.find(
                            (status) => status.value === verificationStatus)?.label}
                        /></>}
                    </Col>
                </Row>

                {(!edit || (edit && !disabled)) && isUserReviewer(externalizationConfigData, user, 'creditRiskManagementForm') && <Row className="mt-3 form-footer">
                    <button
                        className="secondary-btn"
                        type="reset"
                        onClick={handleCancelExternalization}>
                        {t('buttons.cancel')}
                    </button>
                    <button className="primary-btn" disabled={disabled}>{t('buttons.save')}</button>
                </Row>}
            </form>
        </FormProvider>
      <VerifyExternalizationModal
        open={verifyModalOpen}
        formType={externalizationFormConfigData?.formKey}
        formId={defaultData?.id ? defaultData?.id : managingCreditRisksFormId}
        isOpen={setVerifyModalOpen}
      />
    </>);
}

export default ManagingCreditRisksForm;